export default __webpack_public_path__ + "static/media/riassunto-PC.183b82e1.svg";